<template>
  <div>
    <div class="container_info_azul">
      {{ $t('A continuación se muestra la información del software garante para las comunicaciones con TicketBAI. ') }}
    </div>
    <ul>
      <li>
        <span class="font-weight-bold">{{ $t('Identificador de la empresa') }}:</span> {{ infoSoftware.developer_id }}
      </li>
      <li>
        <span class="font-weight-bold">{{ $t('Nombre de la empresa') }}:</span> {{ infoSoftware.developer_name }}
      </li>
      <li>
        <span class="font-weight-bold">{{ $t('Nombre del software') }}:</span> {{ infoSoftware.software_name }}
      </li>
      <li>
        <span class="font-weight-bold">{{ $t('Versión del software') }}:</span> {{ infoSoftware.software_version }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ConfiguracionInformacion",

  data: () => ({
    infoSoftware: {},
  }),

  mounted() {
    this.$store.dispatch('ticketbai/get_info_software').then((response) => {
      this.infoSoftware = response.data;
    });
  },

}
</script>

<style scoped>

</style>
